/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {LogoutMutation, LogoutMutationVariables} from '../types';

export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode;
/** hook для мутации "Logout" */
export function useLogoutMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        LogoutMutation,
        LogoutMutationVariables        
    >,
) {
    return ApolloReactHooks.useMutation<
    LogoutMutation,
    LogoutMutationVariables
    >(LogoutDocument, baseOptions ?? ({} as ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>));
}
